export interface UserRepresentation {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  emailVerified: boolean;
  self: string;
  origin: string;
  createdTimestamp: number;
  enabled: boolean;
  totp: boolean;
  federationLink: string;
  serviceAccountClientId: string;
  requiredActions: string[];
  realmRoles: string[];
  clientRoles: Record<string, string[]>;
  notBefore: number;
  groups: string[];
  access: Record<string, boolean>;
}

export function getUnassignedUser(): UserRepresentation {
  return {
    access: {},
    clientRoles: {},
    createdTimestamp: 0,
    email: '',
    emailVerified: false,
    enabled: false,
    federationLink: '',
    firstName: 'Unassigned',
    groups: [],
    lastName: '',
    notBefore: 0,
    origin: '',
    realmRoles: [],
    requiredActions: [],
    self: '',
    serviceAccountClientId: '',
    totp: false,
    id: "unassigned",
    username: "Unassigned"
  };
}
